import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HierarchyViewModel, connectorHierarchy } from 'src/app/Modules/idms/models/hierarchy-view.model';
import { TaggedItemType } from '../../../models/instance/instance.model';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-hierarchy-option',
    templateUrl: './hierarchy-option.component.html',
    styleUrls: ['./hierarchy-option.component.scss'],
})
export class HierarchyOptionComponent implements OnInit, OnDestroy {
    @Input() idmsHierarchy: HierarchyViewModel[];
    @Input() idmstagItem: HierarchyViewModel[];
    @Input() selectedHierarchy: string;

    @Output() resultedIdmsTagList = new EventEmitter<any>();
    @Output() triggerSaveEvent = new EventEmitter<boolean>();
    destroy$ = new Subject();
    checked: boolean = true;
    disabled: boolean = false;
    namesList: string[];
    tooltip_position = 'above';
    taggedItem: TaggedItemType;
    taggedItemTypeList: connectorHierarchy[];
    activeTaggedItemType: TaggedItemType;

    constructor(
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService,
        private activatedRoute: ActivatedRoute
    ) {
        this.taggedItemTypeList = [];
        this.namesList = [];
    }

    ngOnInit(): void {
        this.globalEmittersService.taggedItemTypeEvent.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            if (response) {
                this.updateProperties(response);
            }
        });

        this.globalEmittersService.activeTaggedItemType.subscribe((response) => {
            if (response) {
                this.activeTaggedItemType = response;
            }
        });
    }

    filterByInstance(idmstagItem: any) {
        this.namesList = [];
        if (idmstagItem[0]?.hierarchy) {
            this.extractPropertyValues(idmstagItem[0]?.hierarchy, 'name', this.namesList);
            this.globalEmittersService.taggedItemNamesList.next(this.namesList);
            return idmstagItem[0].hierarchy.connectorHierarchy;
        } else if (Object.prototype.toString.call(this.taggedItem) !== '[object Array]') {
            this.extractPropertyValues(idmstagItem?.hierarchy?.connectorHierarchy || idmstagItem[0]?.connectorHierarchy, 'name', this.namesList);
            this.globalEmittersService.taggedItemNamesList.next(this.namesList);
            return idmstagItem?.hierarchy?.connectorHierarchy || idmstagItem[0]?.connectorHierarchy;
        } else {
            this.extractPropertyValues(idmstagItem[0].connectorHierarchy, 'name', this.namesList);
            this.globalEmittersService.taggedItemNamesList.next(this.namesList);
            return idmstagItem[0].connectorHierarchy;
        }
    }

    returnIdmsHierarchy() {
        if (this.idmstagItem.length <= 1) {
            return this.idmstagItem[0].connectorHierarchy[0];
        } else {
            return this.idmstagItem[0].hierarchy.connectorHierarchy[0];
        }
    }

    // * update necessary properties
    updateProperties(taggedItemType: TaggedItemType) {
        let selectedIdmsItem = this.idmstagItem.find((x) => x?.isDefault);
        let EditinstanceId = this.activatedRoute.snapshot.paramMap.get('id');
        if (this.idmstagItem.length == 1) {
            this.updateAllOccurrences(selectedIdmsItem, this.activeTaggedItemType, taggedItemType);
            this.resultedIdmsTagList.emit(this.idmstagItem); // * emitting the latest value of views object
            if (EditinstanceId) this.triggerSaveEvent.emit(true);
        } else if (this.idmstagItem.length == 4) {
            this.updateAllOccurrences(selectedIdmsItem, this.activeTaggedItemType, taggedItemType);
            this.resultedIdmsTagList.emit(this.idmstagItem); // * emitting the latest value of views object
            // if (taggedItemType?.schemaRevision) {
            // TODO trigger api call
            // this.globalEmittersService.triggerVersionAdd.next(true);
            if (EditinstanceId) this.triggerSaveEvent.emit(true);
            // }
        }
        this.cd.detectChanges();
    }

    // * recursive function to update the hierarchy object
    updateAllOccurrences(obj, targetObject, updatedObject) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object') {
                    if (Array.isArray(obj[key])) {
                        obj[key].forEach((item, index) => {
                            if (this.isObjectMatch(item, targetObject)) {
                                obj[key][index] = {
                                    ...updatedObject,
                                };
                            } else {
                                this.updateAllOccurrences(item, targetObject, updatedObject);
                            }
                        });
                    } else {
                        if (this.isObjectMatch(obj[key], targetObject)) {
                            obj[key] = {
                                ...updatedObject,
                            };
                        } else {
                            this.updateAllOccurrences(obj[key], targetObject, updatedObject);
                        }
                    }
                }
            }
        }
    }

    extractPropertyValues(obj, propertyName, resultArray) {
        if (!obj || typeof obj !== 'object') {
            return; // Base case, end of recursion
        }
        if (Array.isArray(obj)) {
            obj.forEach((item) => {
                this.extractPropertyValues(item, propertyName, resultArray);
            });
        } else {
            if (obj.hasOwnProperty(propertyName)) {
                resultArray.push(obj[propertyName]);
            }
            for (const key in obj) {
                if (obj.hasOwnProperty(key) && typeof obj[key] === 'object') {
                    this.extractPropertyValues(obj[key], propertyName, resultArray);
                }
            }
        }
    }

    isObjectMatch(obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
